import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';

import container from '@/container';
import {
    FetchServiceContract,
    CONTRACTS,
    AuthServiceContract
} from '@/core/contracts';
import { User, Culture } from '@/dto';
import { locale } from 'devextreme/localization';
import { CultureState } from '.';

interface UserState {
    current?: User;
}

@Module({ name: 'user', namespaced: true })
export default class UserModule extends VuexModule implements UserState {
    public _current?: User = undefined;

    get current() {
        return this._current;
    }

    get userName() {
        return this._current ? this._current.name : 'user';
    }

    get isDev() {
        return this._current ? this._current.isDev : false;
    }

    @Action
    public async fetchUser(): Promise<any> {
        const authService = container.get<AuthServiceContract>(
            CONTRACTS.AuthService
        );

        if (!authService.isAuthenticated || !authService.accessToken) {
            throw new Error('Not authenticated.');
        }

        const fetchService = container.get<FetchServiceContract>(
            CONTRACTS.FetchService
        );

        const payload = await fetchService.get<User>('/users/current');
        this.setUser(payload);

        const currentCulture = CultureState.currentCulture;
        if (currentCulture) {
            locale(currentCulture?.locale);
        }
    }
    @Action
    public async changeCulture(culture: Culture) {
        const endpoint = '/cultures/changecultures/';
        const query = `?cultureInfo=${culture.localName}`;

        const fetchService = container.get<FetchServiceContract>(
            CONTRACTS.FetchService
        );

        await fetchService!.put(endpoint + query, {});

        this.setCulture(culture);
    }

    @Mutation
    private setUser(currentUser: User) {
        this._current = currentUser;
    }
    @Mutation
    private setCulture(culture: Culture) {
        this._current!.culture = culture.localName;
    }
}
